import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

// cubic review (2026-08-16) / Step E1 — guards render sinks (e.g. a leave request's
// attachmentUrl <a href>) against a stored `javascript:`/`data:` value executing when
// clicked. Mirrors the backend's own input-boundary check (leave.router.ts) — this is
// the render-side half, for any pre-existing bad value already in the database.
export function isHttpOrHttpsUrl(value: string): boolean {
    return /^https?:\/\//i.test(value)
}
